export enum AddToCartErrorTypeEnum {
    MISSING_SELECTED_VARIANT = 'missing-selected-variant',
    CART_IS_INITIALIZING = 'cart-is-initializing',
}
